/** Steps項目 */
export const A210_STEPS_ITEMS = [
  { label: 'ID登録' },
  { label: 'パスワード設定メール送信' },
  { label: 'パスワード設定' },
  { label: 'ID登録完了' },
];
